<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :title="$t('common.objectives')" @input="val => { if (!val) hide() }"
        @close="hide">
        <div class="obj-fields">
            <kimsa-text-field v-for="i in 5" :key="i" no-elevation bolder-label dense
                :label="`${$t('common.objective')} ${i}`" :placeholder="`${$t('common.objective')} ${i}`"
                :value="objectives[i - 1]" @change="setObjective(i - 1, $event)" force-value />
        </div>

        <template v-slot:footer>
            <v-btn block depressed x-large color="primary" class="footer-btn black--text" @click="save"
                :loading="loading">
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { db } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "ObjectivesStudentDialog",
    components: { KimsaTextField, BaseDialog },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        studentId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            objectives: Array(5).fill('')
        }
    },
    methods: {
        show() {
            const vm = this
            vm.reset()
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.objectives = vm.value.slice()
            while (vm.objectives.length < 5) vm.objectives.push('')
        },
        setObjective(index, value) {
            this.objectives.splice(index, 1, value)
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                await db.collection('users').doc(vm.studentId).update({
                    'objectives': vm.objectives.filter(obj => obj && obj.trim() !== ''),
                })

                vm.$emit('saved')
                vm.toast(vm.$t('common.objectives_saved'))
                vm.hide()
            })
        },
    },
    watch: {
        value() {
            this.objectives = this.value.slice()
        },
    }
}
</script>

<style scoped>
.obj-fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.footer-btn {
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
}
</style>
